import {
  callSipClientAsync,
  createSipClientAsync,
  deleteSipClientAsync,
  getAllSipClientByLicenseAsync,
  getAllSipClientHistoryByLicenseAsync,
  getAllSipClientHistoryByLicenseCountAsync,
  getLastEndedCallByLoggedUser,
  getSipClientByIdAsync,
  getSipClientHistoryReasonAsync,
  hangupSipClientAsync,
  refuseSipClientAsync,
  toMeetSipClientAsync,
  updateSipClientAsync,
  updateSipClientReasonHistoryAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateSipClientAsync = () => useMutation(createSipClientAsync);

export const useGetSipClientByIdAsync = () =>
  useMutation(getSipClientByIdAsync);

export const useGetAllSipClientByLicenseAsync = () =>
  useMutation(getAllSipClientByLicenseAsync);

export const useUpdateSipClientAsync = () => useMutation(updateSipClientAsync);

export const useDeleteSipClientAsync = () => useMutation(deleteSipClientAsync);

export const useRefuseSipClientAsync = () => useMutation(refuseSipClientAsync);

export const useHangupSipClientAsync = () => useMutation(hangupSipClientAsync);

export const useCallSipClientAsync = () => useMutation(callSipClientAsync);

export const useToMeetSipClientAsync = () => useMutation(toMeetSipClientAsync);

export const useGetAllSipClientHistoryByLicenseAsync = () =>
  useMutation(getAllSipClientHistoryByLicenseAsync);

export const useGetAllSipClientHistoryByLicenseCountAsync = () =>
  useMutation(getAllSipClientHistoryByLicenseCountAsync);

export const useUpdateSipClientReasonHistoryAsync = () =>
  useMutation(updateSipClientReasonHistoryAsync);

export const useGetLastEndedCallByLoggedUser = () =>
  useMutation(getLastEndedCallByLoggedUser);

export const useGetSipClientHistoryReasonAsync = () =>
  useMutation(getSipClientHistoryReasonAsync);
